import { Tabs } from 'antd';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { TItemsTab } from 'shared/types/types';
import { RolesUser } from 'shared/enums';
import { configTabs } from 'shared/helpers/utils';
import { useTabsNavigate } from 'shared/hooks';
import { VacationsModel } from 'entities/vacations-applications';
import { VacationArchive } from './vacationArchive';
import { VacationPull } from './vacationPull';
import style from './index.module.scss';

const allRoles = [
  RolesUser.HRDirector,
  RolesUser.Consultant,
  RolesUser.Employee,
  RolesUser.FirstLine,
  RolesUser.SecondLine,
];

const itemsTab: TItemsTab = [
  {
    label: 'Общий список заявок',
    key: 'new',
    children: <VacationPull />,
    role: allRoles,
  },
  {
    label: 'Архив',
    key: 'myArchive',
    children: <VacationArchive />,
    role: allRoles,
  },
];

export const VacationsApplication = () => {
  const [activeTab, handler] = useTabsNavigate('vacation', itemsTab[0].key);
  const profile = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { role } = profile;

  const tabPane = configTabs(role, itemsTab);
  const { vacations: vacationsData } = useAppSelector(VacationsModel.Vacations.selectors.getVacations);

  return (
    <>
      <div className={style.vacations__panel}>
        <h3>Согласование отпусков</h3>
      </div>

      <div className={style.wrap}>
        {role && (
          <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane>
            {tabPane &&
              tabPane.map(el => {
                return (
                  <Tabs.TabPane tab={el.label} key={el.key}>
                    {el.children}
                  </Tabs.TabPane>
                );
              })}
          </Tabs>
        )}
      </div>
    </>
  );
};
